var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLuggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    enableBackground: "new 0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#282D33",
    points: "48.59,11.032 44.59,11.032 44.59,4.725 26.791,4.725 26.791,11.032 22.791,11.032 22.791,0.725  48.59,0.725  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M30.571,119.948H5.963c-3.288,0-5.963-2.689-5.963-5.996V20.041c0-3.307,2.675-5.996,5.963-5.996h59.456 c3.288,0,5.963,2.689,5.963,5.996V46.11h-4V20.041c0-1.101-0.881-1.996-1.963-1.996H5.963C4.88,18.045,4,18.94,4,20.041v93.911 c0,1.101,0.88,1.996,1.963,1.996h24.608V119.948z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.606,
    y: 119.947,
    fill: "#282D33",
    width: 4,
    height: 6.66
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M30.571,110.624h-15.69c-3.289,0-5.964-2.689-5.964-5.996V81.316c0-3.307,2.675-5.996,5.964-5.996H30.57 v4H14.881c-1.083,0-1.964,0.896-1.964,1.996v23.312c0,1.101,0.881,1.996,1.964,1.996h15.69V110.624z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M45.93,45.352H25.451c-6.931,0-12.57-5.678-12.57-12.656v-5.994h4v5.994c0,4.773,3.845,8.656,8.57,8.656 H45.93c4.726,0,8.57-3.883,8.57-8.656v-5.994h4v5.994C58.5,39.674,52.861,45.352,45.93,45.352z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.863,
    y: 24.701,
    fill: "#282D33",
    width: 55.654,
    height: 4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M119.395,127.275H44.746c-4.745,0-8.605-3.886-8.605-8.662V85.313h4v33.301 c0,2.57,2.066,4.662,4.605,4.662h74.648c2.539,0,4.605-2.092,4.605-4.662V85.313h4v33.301 C128,123.39,124.14,127.275,119.395,127.275z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M119.395,113.953h-19.158v-4h19.158c2.538,0,4.604-2.091,4.604-4.66V71.992h4v33.301 C127.998,110.068,124.139,113.953,119.395,113.953z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M64.123,113.953H44.745c-4.745,0-8.606-3.885-8.606-8.66V71.992h4v33.301c0,2.569,2.066,4.66,4.606,4.66 h19.378V113.953z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M119.395,101.3H44.746c-4.745,0-8.605-3.885-8.605-8.659V59.337c0-4.775,3.86-8.66,8.605-8.66h74.646 c4.746,0,8.606,3.885,8.606,8.66v33.304c0.001,2.31-0.892,4.482-2.514,6.117C123.86,100.397,121.697,101.3,119.395,101.3z  M44.746,54.677c-2.539,0-4.605,2.09-4.605,4.66v33.304c0,2.569,2.066,4.659,4.605,4.659h74.648c2.539,0,4.605-2.09,4.605-4.659 l-0.001-33.304c0-2.57-2.066-4.66-4.606-4.66H44.746z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48.71,
    y: 61.333,
    fill: "#282D33",
    width: 66.722,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M91.021,120.016H73.118c-2.845,0-5.159-2.326-5.159-5.186v-6.873h4v6.873c0,0.653,0.52,1.186,1.159,1.186 h17.903c0.64,0,1.16-0.532,1.16-1.186v-6.873h4v6.873C96.182,117.689,93.867,120.016,91.021,120.016z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggage);
export default __webpack_public_path__ + "static/media/luggage.350f23cc3c212c6a72e6999cad7d4a4f.svg";
export { ForwardRef as ReactComponent };